module.exports = __webpack_public_path__ + "img/mb_hm_block02_tc.64b6f0e6.jpg";